import * as z from "zod/v4";

export const ConnectionStatusSchema = z.enum([
  "CONNECTED",
  "DISCONNECTED",
  "ERROR",
]);
export type ConnectionStatus = z.infer<typeof ConnectionStatusSchema>;
